import React, { useEffect, useRef } from 'react';
import { LegalFooter } from '@dowty/legal';
import { useNavigate } from 'react-router-dom';

const links = {
    impressum: '/impressum',
    privacy: '/datenschutz',
};

const RouterLegalFooter: React.FC = () => {
    const navigate = useNavigate();
    const footerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const footer = footerRef.current;
        if (!footer) return;

        const handleClick = (event: MouseEvent) => {
            if (!(event.target instanceof Element)) return;
            const link = event.target.closest<HTMLAnchorElement>('.dowty-legal-footer a[href^="/"]');
            if (!link || link.closest('.ui-shell') || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            navigate(link.getAttribute('href')!);
        };

        footer.addEventListener('click', handleClick);
        return () => footer.removeEventListener('click', handleClick);
    }, [navigate]);

    return <div ref={footerRef} className="sportdings-legal-footer">
        <LegalFooter links={links} />
    </div>;
};

export default RouterLegalFooter;
